export enum ExpertPrefixEnum {
    LIC = 'Lic.',
    DRA = 'Dra.',
    DR = 'Dr.'
}
